import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { alignmentCssVariableValues, ZIndexLayer } from "~/lib/styles";

import { NewsletterArticleContent } from "./content";
import { NewsletterArticleHeader } from "./header";
import { NewsletterArticleIssues } from "./issues";
import { NewsletterArticleWidget } from "./widget";

export const Outer = styled.div`
  margin-inline-start: calc(
    (
        ${alignmentCssVariableValues.pageAlignmentPaddingInline} +
          ${alignmentCssVariableValues.contentAlignmentPaddingInline}
      ) * -1
  );
  margin-inline-end: calc(
    (
        ${alignmentCssVariableValues.pageAlignmentPaddingInline} +
          ${alignmentCssVariableValues.contentAlignmentPaddingInline}
      ) * -1
  );

  ${props => props.theme.breakpoints.down("tablet")} {
    overflow: hidden;
  }
`;

export const Container = styled.div`
  max-inline-size: 876px;
  margin-inline-start: auto;
  margin-inline-end: auto;
  padding-block-start: 40px;
  padding-block-end: 49px;
`;

export const StyledNewsletterArticleHeader = styled(NewsletterArticleHeader)`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-block-end: 40.5px;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-block: 0;
  padding-inline: 20px;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block: 0;
    padding-inline: 44px;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    padding: 0;
  }
`;

export const Content = styled.div`
  position: relative;
`;

export const IframeContainer = styled.div`
  margin-block-start: -82.5px;
  padding-block: 102.5px 59px;
  padding-inline: 10px;

  border: 1px solid #000000;
  border-width: 1px 0;

  background-color: #f7f7f7;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-start: -52.5px;
    padding-block: 73px 60px;
    padding-inline: 98px;
  }
`;

export const Bottom = styled.div`
  padding-block: 46px 0;
  padding-inline: 20px;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block: 46px 0;
    padding-inline: 98px;
  }
`;

export const NewsletterArticleWidgetContainer = styled.div`
  position: relative;
  z-index: ${ZIndexLayer.NewsletterArticleFloatingWidget};

  margin-block: 0;
  margin-inline: 20px;
  ${props => props.theme.breakpoints.up("tablet")} {
    position: sticky;
    inset-block-start: 63px;
  }
`;

export const StyledNewsletterArticleWidget = styled(NewsletterArticleWidget)`
  inline-size: 100%;
  max-inline-size: 720px;
  margin-block: 0;
  margin-inline: auto;
  padding-block: 16px;
  padding-inline: 20px;

  background-color: #ffffff;

  box-shadow: 0 0 1px 2px rgb(0 0 0 / 0.02), 2px 3px 10px 0 rgb(0 0 0 / 0.05);
  ${props => props.theme.breakpoints.up("tablet")} {
    block-size: 105px;
  }
`;

export const StyledNewsletterArticleContent = styled(NewsletterArticleContent)`
  inline-size: 100%;
  min-block-size: 100vh;

  background-color: #ffffff;
`;

export const StyledNewsletterArticleIssues = styled(NewsletterArticleIssues)`
  position: absolute;
  z-index: ${ZIndexLayer.NewsletterArticleFloatingWidget - 1};

  display: flex;
  justify-content: center;

  inline-size: 100%;

  transform: translateY(-50%);
`;

export const ShareContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-block-start: 40px;
  margin-block-end: 8px;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-start: 60px;
    margin-block-end: 20px;
  }
`;

export const CommentTrigger = styled.span`
  flex: 1;

  ${props => props.theme.breakpoints.up("tablet")} {
    max-inline-size: 335px;
  }
`;

export const ShareWidget = styled.span`
  display: none;
  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const AuthorDetail = styled.div`
  margin-block-end: 8px;
`;

export const Topics = styled.div`
  position: relative;
  z-index: ${ZIndexLayer.NewsletterArticleFloatingWidget - 2};

  & > div {
    gap: 0;
  }

  h2 {
    margin-block-end: 8px;
  }

  a {
    font-size: 16px;
    font-family: ${fontRobotoCondensed};
    line-height: 20px;
  }
`;

type Props = {
  $isHidden: boolean;
};

export const StyledNewsletterArticleWidgetBottom = styled(NewsletterArticleWidget)<Props>`
  position: fixed;
  inset-block-end: 0;
  z-index: ${ZIndexLayer.NewsletterArticleFloatingWidget};

  inline-size: 100%;
  padding-block: 12px;
  padding-inline: 26px;

  background: #ffffff;

  opacity: ${props => (props.$isHidden ? "0" : "1")};
  transform: ${props => (props.$isHidden ? "translateY(100%);" : "translateY(0%);")};

  transition: transform 0.1s, opacity 0.1s;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: none;
  }
`;
